<template>
  <div class="d-flex mt-3">
    <div>
      <div class="d-flex justify-content-between mb-3 labels">
        <span v-if="startText" class="pr-1">{{ startText }}</span>
        <span v-else class="pr-1">{{ $t('QUIZZES.LABEL.NOT_LIKELY') }}</span>
        <span v-if="endText">{{ endText }}</span>
        <span v-else>{{ $t('QUIZZES.LABEL.EXTREMELY_LIKELY') }}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span v-for="i in questionRange" :key="i">
          <span class="checkmark mr-2">
            <i
              v-if="i === scaleSelectedItem"
              class="fas fa-check-circle c-light-green"
            ></i>
            <i v-else class="fal fa-circle c-medium-gray"></i>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMOpinionScalePreview',
  props: {
    scaleSelectedItem: {
      type: Number,
      default: null,
    },
    questionRange: {
      tyep: Number,
      default: null,
    },
    startText: {
      tyep: String,
      default: null,
    },
    endText: {
      tyep: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.labels {
  font-size: 10px;
  color: $charcoal;
}
</style>
